module.exports = __webpack_public_path__ + "6641ef02925a1f0b7d78e72e35416401.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/SohoGothicPro/SohoGothicProLight.ttf
// module id = 8044
// module chunks = 0